var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (config, item, obj, playinline) {
jade_mixins["video-stream"] = jade_interp = function(videoUrl, playsinline, controls, klass, poster){
var block = (this && this.block), attributes = (this && this.attributes) || {};
playinline = playinline || true
controls = controls || true
klass = klass || 'video vjs-fluid'
var cloudinaryVideoFolderUrl = config.CLOUDINARY_CDN_URL+config.CLOUDINARY_VIDEO_FOLDER
var streamUrl = ''
if ( videoUrl && videoUrl.indexOf(cloudinaryVideoFolderUrl) > -1)
{
streamUrl = videoUrl.replace(cloudinaryVideoFolderUrl, cloudinaryVideoFolderUrl+'sp_full_hd/')
streamUrl = streamUrl.replace('.mp4', '.m3u8')
}
buf.push("<video" + (jade.attr("webkit-playsinline", playsinline, true, false)) + (jade.attr("controls", controls, true, false)) + " preload=\"auto\"" + (jade.attr("dir", config.direction, true, false)) + (jade.attr("poster", poster, true, false)) + (jade.cls(['video-js',klass], [null,true])) + "><source" + (jade.attr("src", videoUrl, true, false)) + "/>");
if ( streamUrl)
{
buf.push("<source" + (jade.attr("src", streamUrl, true, false)) + "/>");
}
buf.push("</video>");
};
switch (item.type){
case "image":
buf.push("<li" + (jade.attr("data-content", obj.image, true, false)) + " class=\"multi-content-wrapper multi-content-wrapper-image block-md\"><div class=\"block-sm multi-content-media\"><img" + (jade.attr("src", item.url, true, false)) + " class=\"multi-content multi-content-image\"/></div></li>");
  break;
case "video":
buf.push("<li" + (jade.attr("data-id", item.id, true, false)) + " class=\"multi-content-wrapper multi-content-wrapper-video block-md\"><div class=\"block-sm multi-content-media block-lt\">");
jade_mixins["video-stream"](item.url, true, true, "multi-content multi-content-video", item.thumbmail);
buf.push("</div><div class=\"video-info\"><div class=\"video-actions\"><span class=\"icon-group\"><span class=\"icon-group-entry js-like-button hidden\"><span class=\"icon icon-heart js-like-button\"></span><span class=\"video-like-count text-light\">" + (jade.escape(null == (jade_interp = '10') ? "" : jade_interp)) + "</span></span><span class=\"icon-group-entry js-comment-button\">");
if ( item.commentCount > 0 )
{
buf.push("<span class=\"icon icon-chat-count\"></span>");
}
else
{
buf.push("<span class=\"icon icon-chat\"></span>");
}
buf.push("<span class=\"video-comment-count text-light js-video-comment-count\">" + (jade.escape(null == (jade_interp = item.commentCount || 0) ? "" : jade_interp)) + "</span></span></span><span class=\"icon icon-flag js-flag-button hidden\"></span></div><span class=\"video-title\">" + (null == (jade_interp = item.title) ? "" : jade_interp) + "</span></div></li>");
  break;
}}.call(this,"config" in locals_for_with?locals_for_with.config:typeof config!=="undefined"?config:undefined,"item" in locals_for_with?locals_for_with.item:typeof item!=="undefined"?item:undefined,"obj" in locals_for_with?locals_for_with.obj:typeof obj!=="undefined"?obj:undefined,"playinline" in locals_for_with?locals_for_with.playinline:typeof playinline!=="undefined"?playinline:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}